<template>
	<div>
		<Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
			<template #action>
				<div class="content-container-app overflow-auto">
					<div class="text-lg text-blue-800 font-bold" v-if="isNew">新規登録</div>
					<div class="text-lg text-blue-800 font-bold" v-else>編集</div>
					<div class="w-full mt-3">
						<!-- カテゴリ -->
						<div class="text-xs mb-1 text-gray-700 font-bold">
							対象カテゴリーを選択してください<span class="-top-0.5 ml-1 text-red-500"> * </span>
							<span class="font-bold text-xs pl-5 text-red-600">※「業務依頼」は全てのサブタスク表示</span>
							<span class="cursor-pointer pl-10 text-indigo-700 text-xs" @click="allCheck(true)">全選択</span>
							<span class="cursor-pointer pl-5 text-indigo-700 text-xs" @click="allCheck(false)">全解除</span>
						</div>
						<div class="flex mx-auto w-fit text-xs font-bold text-white flex-wrap gap-2 text-center">
							<div v-for="(c , i) in categorys" :key="'c'+i" @click="checkCategory(c.value)" class="cursor-pointer category p-2 truncate" :class="sub.category&&sub.category.includes(c.value)?'bg-blue-600':'bg-gray-300'">
								{{ c.text }}
							</div>
						</div>

						<!-- セット名 -->
						<div class="mt-5">
							<WmsTextInput 
								name="name" 
								caption="名前"
								:required="true"
								v-model="sub.name"
							/>
						</div>

						<div class="flex mt-5 mb-1">
							<div class="text-xs text-gray-700 font-bold mt-auto flex">
                サブタスク
                
                <!-- 並べ替え -->
                <div class="toggle flex items-center mt-auto ml-10 mr-5">
                  <span class="mr-1 text-green-700 font-bold text-xs">並べ替え</span>
                  <Toggle v-model="sortable" size="small" />
                </div>
              </div>
							<PrimaryButton text="追加" size="sm bg-blue-700 py-1 ml-auto" @click="add()" />
						</div>
            
            <draggable
              key="sub"
              :list="sub.group"
              direction="vertical"
              handle=".row-drag-handle"
              tag="div"
            >
              <div v-for="(row, i) in sub.group" :key="i" class="mb-1">
                <div class="flex">
                  <div>
                    <div v-if="sortable" class="mx-1.5 items-center my-1 row-drag-handle prasp">
                      <MenuIcon class="text-gray-400" />
                    </div>
                    <div v-else class="ml-1 my-1 w-8">
                      {{ i + 1 }}.
                    </div>
                  </div>
                  <select
                    v-model="sub.group[i].task"
                    class="border-gray w-full rounded py-1 text-sm"
                  >
										<option v-for="(task, index) in sub2" :value="task.name" :key="i + 's' + index">
											{{ task.name }}
										</option>
                  </select>

                  <!-- 削除 -->
                  <div @click="deleteRow(i)" class="ml-2">
                    <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-7 h-7 my-auto" />
                  </div>
                </div>
              </div>
            </draggable>

						<div>
							<PrimaryButton text="登録" size="normal px-10 mb-5 mt-5 w-full" @click="register()" />
						</div>
						<div class="text-transparent">{{reload}}</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>
<script>

import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
import { TrashIcon, MenuIcon } from '@vue-hero-icons/solid'
import { categorySelections } from '@libs/constants'
import Toggle from '@components/Toggle.vue'
import draggable from "vuedraggable"
import * as taskRequestManager from '@managers/taskRequestManager'
import * as logManager from '@managers/logManager'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'

const FORMID = 'task_request_set_master'

const SUB = {
	category: [],
	name: '',
	group: [{ task: '' }]
}

export default {
	components: {
		Modal,
		PrimaryButton,
		WmsTextInput,
		TrashIcon,
    MenuIcon,
    Toggle,
    draggable
	},

	props: {
		target: {
			type: Object
		},
		subList: {
			type: Array
		},
		open: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			reload: 0,
			// 新規作成
			isNew: false,
			// サブタスク依頼
			sub: utils.clone(SUB),
			// サブタスク
			sub2: [],
			// サブタスク（全データ）
			tasks: [],
      // 並べ替え
      sortable: false,
			// メインタスクカテゴリー
			categorys: categorySelections.filter((c) => { return c.text != '業務依頼' })
		}
	},

	watch: {
		async open() {
			if (!this.open) {
				return
			}
			this.getTarget()
			await this.getSubTask()
		}
	},

	methods: {
		/**
		 * 表示するデータ取得
		 */
		getTarget() {
			// 編集の場合
			if (this.target && Object.keys(this.target).length) {
				this.isNew = false
				this.sub = utils.clone(this.target)
			// 新規の場合
			} else {
				this.isNew = true
				this.sub = utils.clone(SUB)
			}
		},

		/**
		 * サブタスク取得
		 */
		async getSubTask() {
			this.tasks = []
			this.sub2 = []
			this.tasks = await taskRequestManager.getTaskMst(this)
			this.getSub2()
		},

		/**
		 * 対象のカテゴリと同じサブタスクを取得
		 */
		getSub2() {
			this.sub2 = []
			if (this.sub.category && this.sub.category.length) {
				if (this.sub.category.length == 1 && this.sub.category[0] == '業務依頼') {
					this.sub2 = utils.clone(this.tasks)
				} else {
					const result = this.tasks.filter(task =>
						this.sub.category.some(cat => cat != '業務依頼' && task.category.includes(cat))
					)
					this.sub2 = result
				}

			} else {
				this.sub2 = utils.clone(this.tasks)
			}
		},

		/**
		 * サブタスク追加
		 */
		add() {
			if (!this.sub.group) {
				this.sub.group = [{ task: '' }]
			} else {
				this.sub.group.push({ task: '' })
			}
		},

		/**
		 * サブタスク削除
		 */
		deleteRow(i) {
			this.sub.group.splice(i, 1)
			if (!this.sub.group || !this.sub.group.length) {
				this.add()
			}
		},

		/**
		 * 初期化
		 */
		closed() {
			// 新規作成
			this.isNew = false
			// サブタスク依頼セット
			this.sub = utils.clone(SUB)
			// スタッフリスト
			this.staffList = []
		},

		/**
		 * 登録処理
		 */
		async register() {
			// 必須
			if (!this.sub.category || !this.sub.category.length) {
				await this.errRequired('カテゴリ')
				return
			}
			if (!this.sub.name) {
				await this.errRequired('名前')
				return
			}
			// サブタスクを選んでいるか
			const notSub = this.sub.group.find((g) => {
				return !g.task
			})
			if (notSub) {
				await dialogs.showErrorDialog('サブタスク未選択があります', 'サブタスクを選択するか、削除してください。')
				return
			}

			// 名前がかぶっていないか
			const err = this.subList.find((s) => {
				return (s.name == this.sub.name && s._id != this.sub._id)
			})
			if (err && err.name) {
				await dialogs.showErrorDialog('同じ名前が既にあります。', '同じ名前が既に存在します。\r\n名前を変更してください。')
				return
			}

			// 登録
			try {
				// 新規
				if (this.isNew) {
					await this.$pigeon.registerTask(FORMID, this.sub, {})
				// 更新
				} else {
					await this.$pigeon.updateTask(this.sub._id, this.sub, {})
				}

				sessionStorage.removeItem('subTaskSetMst')

				// ログ登録
				logManager.recordingByRegist(
					this,
					this.isNew,
					'サブタスク依頼セットマスタ',
					'サブタスク依頼セット（' + this.sub.task + '）'
				)
			} catch (error) {
				alert(error)
			}
				this.$emit('modalClose')
				this.closed()
		},

		/**
		 * 必須項目アラート
		 * @param item 項目名
		 */
		async errRequired(item) {
				await dialogs.showErrorDialog(item + 'は必須です', item + 'が選択されていません。')
		},

		/**
		 * 全選択、全選択解除
		 */
		allCheck(val) {
			// 全選択
			if (val) {
				this.sub.category = this.categorys.map((c) => c.value)
			// 全解除
			} else {
				this.sub.category = []
			}
			this.reload++
		},

		/**
		 * カテゴリクリック
		 */
		checkCategory(val) {
			// 同じカテゴリをクリック
			if (this.sub.category && this.sub.category.includes(val)) {
				this.sub.category = this.sub.category.filter((c) => {return c != val})
			} else {
				if (!this.sub.category) {
					this.sub.category = []
				}
				this.sub.category.push(val)
			}
			this.getSub2()
			this.reload++
		}
	}
}

</script>
<style scoped>
.content-container-app {
	width: 800px;
	padding: 0 10px;
}

.border-gray {
	border: solid #d3cfcf 1px;
}

.drop {
	width: 92%;
	margin-right: auto;
}

.category {
	width: 120px
}
</style>